import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { ColorTheme } from "@figma/fpl-themes";
//#region src/icons/icon-24-design-brandicon.tsx
/**
* icon.24.design.brandicon
*
* Keywords: figma, pen, editor
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iIzBkOTlmZiIgZD0iTTAgNWE1IDUgMCAwIDEgNS01aDE0YTUgNSAwIDAgMSA1IDV2MTRhNSA1IDAgMCAxLTUgNUg1YTUgNSAwIDAgMS01LTV6Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTYuMzg1IDUuMjEyYTEgMSAwIDAgMSAuODEtLjE5MWw1Ljk4MSAxLjE5NkE2IDYgMCAwIDEgMTggMTIuMXYuNDg3bC43MDYuNzA3YTEgMSAwIDAgMSAwIDEuNDE0bC00IDRhMSAxIDAgMCAxLTEuNDEzIDBsLS43MDgtLjcwN2gtLjQ4N2E2IDYgMCAwIDEtNS44ODMtNC44MjNMNS4wMiA3LjE5OGExIDEgMCAwIDEgLjI3My0uOTA0bDEtMXptLjQ2OC45MzYgMy43NjggMy43NjdhMi41IDIuNSAwIDEgMS0uNzA3LjcwN0w2LjE0NiA2Ljg1NSA2IDdsMS4xOTYgNS45OEE1IDUgMCAwIDAgMTIuMDk4IDE3SDEzbDEgMSA0LTQtMS0xdi0uOWE1IDUgMCAwIDAtMy44MDItNC44NTVsLS4yMTctLjA0OEw3IDYuMDAxek0xMiAxMC41YTEuNSAxLjUgMCAxIDAgMCAzIDEuNSAxLjUgMCAwIDAgMC0zIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=7584-9521
*/
const Icon24DesignBrandicon = memo(function Icon24DesignBrandicon(props) {
	return /* @__PURE__ */ jsx(ColorTheme, {
		brand: "design",
		children: /* @__PURE__ */ jsxs("svg", {
			width: "24",
			height: "24",
			fill: "none",
			viewBox: "0 0 24 24",
			...props,
			"data-fpl-icon-size": "24",
			children: [/* @__PURE__ */ jsx("path", {
				fill: "var(--color-bg-brand)",
				d: "M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "var(--color-icon-onbrand)",
				d: "M6.385 5.212a1 1 0 0 1 .81-.191l5.981 1.196A6 6 0 0 1 18 12.1v.487l.706.707a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.413 0l-.708-.707h-.487a6 6 0 0 1-5.883-4.823L5.02 7.198a1 1 0 0 1 .273-.904l1-1zm.468.936 3.768 3.767a2.5 2.5 0 1 1-.707.707L6.146 6.855 6 7l1.196 5.98A5 5 0 0 0 12.098 17H13l1 1 4-4-1-1v-.9a5 5 0 0 0-3.802-4.855l-.217-.048L7 6.001zM12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
			})]
		})
	});
});
//#endregion
export { Icon24DesignBrandicon };

//# sourceMappingURL=icon-24-design-brandicon.js.map